import React from 'react';

import { useReportItemsFilter } from 'src/hooks/reports';

import { VERIFICATION_REQUESTS_TABLE_COLUMNS_PEO_STAFF } from '../constants';

import { VerificationRequestsInnerTable } from './VerificationRequestsInnerTable';

export const VerificationRequestsTablePEOAdmin: React.FC = () => {
  const { filter } = useReportItemsFilter();

  return (
    <VerificationRequestsInnerTable
      columns={VERIFICATION_REQUESTS_TABLE_COLUMNS_PEO_STAFF}
      filter={filter}
    />
  );
};
